import React, { Component } from "react";
import {
  getMonthAndDate,
  saveCloseRegistration,
  showHideMatchInvite,
} from "../../../../../../utils/common.utils";
import { HiUserAdd } from "react-icons/hi";
import { HiChatBubbleLeftRight } from "react-icons/hi2";
import { Modal } from "react-bootstrap";
import MatchInvite from "../../../../../popup/MatchInvite";
import AcceptInvite from "../../../../../popup/AcceptInvite";
import {
  addParticipantInTournament,
  getMyTeams,
  getStageDetails,
} from "../../../../../../utils/Tournament.utils";
import Registration from "../../../Registration";
import winCup from "../../../../../../images/icon/winCup.png";
import Scoreboard from "../../../Scoreboard";
import Image from "../../../../../common/Image";
import { trackEvent } from "../../../../../analytics/GoogleAnalyticsTrackEvents";
import { profile } from "../../../../../../utils/localstorage.utils";
import { toast } from "react-toastify";
import MatchesApis from "../../../../../../helper/matches.api";

export default class FFASingleEliminationMatches extends Component {
  constructor(props) {
    super(props);
    this.state = {
      stageDetails: props?.stageDetails ? props.stageDetails : null,
      tournamentDetails: props?.tournamentDetails ? props.tournamentDetails : null,
      subType: props?.subType,
      teamsArray: [],
      initiateRegistration: false,
      selectedMatchDetail: null,
      selectedMatchIndex: null,
      selectedTeams: null,
      showRegistrationScreen: false,
      matchIndex: "0.0",
      showScoreBoard: false,
      matchDetails: null,
      matchNo: null,
      openQuickTeamRegister: props.openQuickTeamRegister || false,
    };

    this.enableLoading = false;
  }

  componentDidMount() {
    saveCloseRegistration(this.closeRegistrationScreen);
  }

  UNSAFE_componentWillReceiveProps(newProps) {
    if (!this.enableLoading) {
      this.setState({
        stageDetails: newProps?.stageDetails ? newProps.stageDetails : this.state.stageDetails,
        tournamentDetails: newProps?.tournamentDetails
          ? newProps.tournamentDetails
          : this.state.tournamentDetails,
      });
    }
  }

  // START :: Tournament Registration  Process
  registerForTournament = (e, matchDetail, matchIndex) => {
    e.preventDefault();
    this.enableLoading = true;

    // Track match registration attempt
    trackEvent("tournament_match_register_attempt", {
      tournament_id: this.state.tournamentDetails?._id,
      tournament_name: this.state.tournamentDetails?.name,
      match_id: matchDetail?._id,
      match_number: matchIndex,
      participant_type: this.state.tournamentDetails?.participantType,
      game_name: this.state.tournamentDetails?.gameDetails?.name,
      has_entry_fee: this.state.tournamentDetails?.entryFeeAndPrizeDetails?.entryFee === true,
      tournament_type: this.state.tournamentDetails?.stages[0]?.type,
      tournament_subtype: this.state.stageDetails?.subType || this.props.stageDetails?.subType,
    });

    // Check for teams first in all cases when participant type is TEAM
    if (this.state.tournamentDetails?.participantType === "TEAM") {
      // First check if teams exist before proceeding with any registration flow
      this.setState({
        selectedMatchDetail: matchDetail,
        selectedMatchIndex: matchIndex,
      });

      getMyTeams(
        this.state.tournamentDetails.gameId,
        matchDetail,
        // Only use this callback if teams exist and we don't have entry fee
        this.state.tournamentDetails?.entryFeeAndPrizeDetails?.entryFee !== true
          ? this.addParticipantInTournament
          : null,
        (success, data) => {
          if (success && data.teamsArray && data.teamsArray.length > 0) {
            // Teams exist, proceed with appropriate flow
            // Track existing teams found
            trackEvent("tournament_match_teams_found", {
              tournament_id: this.state.tournamentDetails?._id,
              match_id: matchDetail?._id,
              match_number: matchIndex,
              team_count: data.teamsArray.length,
              has_entry_fee:
                this.state.tournamentDetails?.entryFeeAndPrizeDetails?.entryFee === true,
              tournament_type: this.state.tournamentDetails?.stages[0]?.type,
              tournament_subtype:
                this.state.stageDetails?.subType || this.props.stageDetails?.subType,
            });

            if (this.state.tournamentDetails?.entryFeeAndPrizeDetails?.entryFee === true) {
              // For tournaments with entry fees, go to registration screen
              this.switchRegistrationScreens(matchDetail, matchIndex);
            } else {
              // For tournaments without entry fees, show team selection modal
              this.setState({
                teamsArray: data.teamsArray,
                initiateRegistration: true,
                selectedMatchDetail: data.selectedMatchDetail,
              });
            }
          } else {
            // Track no teams found
            trackEvent("tournament_match_no_teams", {
              tournament_id: this.state.tournamentDetails?._id,
              match_id: matchDetail?._id,
              match_number: matchIndex,
              tournament_type: this.state.tournamentDetails?.stages[0]?.type,
              tournament_subtype:
                this.state.stageDetails?.subType || this.props.stageDetails?.subType,
            });

            this.props.toggleQuickTeamRegister(true);
            // Reset any ongoing registration process
            this.resetRegistration();
          }
        }
      );
    } else {
      // Track single participant registration
      trackEvent("tournament_match_single_register", {
        tournament_id: this.state.tournamentDetails?._id,
        match_id: matchDetail?._id,
        match_number: matchIndex,
        tournament_type: this.state.tournamentDetails?.stages[0]?.type,
        tournament_subtype: this.state.stageDetails?.subType || this.props.stageDetails?.subType,
      });

      this.setState({
        initiateRegistration: true,
        selectedMatchDetail: matchDetail,
        selectedMatchIndex: matchIndex,
      });
    }
  };

  selectTeams = (success, data) => {
    if (success) {
      this.setState({
        teamsArray: data.teamsArray,
        initiateRegistration: true,
        selectedMatchDetail: data.selectedMatchDetail,
      });
    } else {
      // toast.warning(ERROR.NO_TEAM_FOR_TOURNAMENT);
      this.props.toggleQuickTeamRegister(true);
    }
  };

  addParticipantInTournament = (matchId, teamId) => {
    // Track participant addition attempt
    trackEvent("tournament_match_add_participant", {
      tournament_id: this.state.tournamentDetails?._id,
      match_id: matchId,
      team_id: teamId,
      has_entry_fee: this.state.tournamentDetails?.entryFeeAndPrizeDetails?.entryFee === true,
      tournament_type: this.state.tournamentDetails?.stages[0]?.type,
      tournament_subtype: this.state.stageDetails?.subType || this.props.stageDetails?.subType,
    });

    if (this.state.tournamentDetails?.entryFeeAndPrizeDetails?.entryFee === true) {
      this.switchRegistrationScreens(
        this.state.selectedMatchDetail,
        this.state.selectedMatchIndex,
        teamId
      );
      this.resetRegistration();
    } else {
      addParticipantInTournament(
        response => {
          // Track successful participant addition
          trackEvent("tournament_match_participant_added", {
            tournament_id: this.state.tournamentDetails?._id,
            match_id: matchId,
            team_id: teamId,
            success: true,
            tournament_type: this.state.tournamentDetails?.stages[0]?.type,
            tournament_subtype:
              this.state.stageDetails?.subType || this.props.stageDetails?.subType,
          });
          this.updateStageDetails(response);
        },
        this.state.selectedMatchDetail._id,
        teamId,
        this.state.stageDetails,
        this.state.tournamentDetails
      );
    }
  };

  onClickOpenInvite = joinTeamId => {
    // Track invite acceptance
    trackEvent("tournament_match_invite_accept", {
      tournament_id: this.state.tournamentDetails?._id,
      match_id: this.state.selectedMatchDetail?._id,
      team_id: joinTeamId,
      tournament_type: this.state.tournamentDetails?.stages[0]?.type,
      tournament_subtype: this.state.stageDetails?.subType || this.props.stageDetails?.subType,
    });

    this.setState({
      initiateRegistration: !this.state.initiateRegistration,
    });
    if (joinTeamId) {
      addParticipantInTournament(
        this.updateStageDetails,
        this.state.selectedMatchDetail?._id,
        joinTeamId,
        this.state.stageDetails,
        this.state.tournamentDetails
      );
    }
    this.resetRegistration();
  };

  updateStageDetails = response => {
    this.setState({
      stageDetails: response,
    });
    this.resetRegistration();
  };

  resetRegistration = () => {
    this.setState({
      teamsArray: [],
      initiateRegistration: false,
      selectedMatchDetail: null,
      selectedMatchIndex: null,
      selectedTeams: null,
    });
    //this.enableLoading = false;
  };

  switchRegistrationScreens = (matchDetail, matchIndex, teamId) => {
    this.setState({
      showRegistrationScreen: !this.state.showRegistrationScreen,
      selectedMatchDetail: matchDetail,
      matchIndex: matchIndex,
      selectedTeams: teamId ? teamId : null,
    });
  };

  // END :: Tournament Registration Process

  closeRegistrationScreen = () => {
    getStageDetails(this.state.tournamentDetails?._id, this.props.index, this.setData);
  };

  setData = values => {
    if (values) {
      this.setState({
        stageDetails: values,
        showRegistrationScreen: false,
      });
    } else {
      this.setState({
        showRegistrationScreen: false,
      });
    }
  };

  onClickRegister = () => {
    // if (profile()?.discordProfile?.discordUsername) {
    return (
      <Modal.Body>
        <AcceptInvite
          clearInvitations={this.resetRegistration}
          tournamentId={this.state.tournamentDetails?._id}
          addParticipantInTournament={this.addParticipantInTournament}
          joinTeamRole={null}
          close={this.resetRegistration}
          type="add"
          info={{}}
          title="Register"
          role="player"
          matchId={this.state.selectedMatchDetail?._id}
          isTournamentInvitation={true}
        />
      </Modal.Body>
    );
    // } else {
    //     return (
    //         <Modal.Body>
    //             <ConfirmationModal confirm={linkWithDiscord()} onClickOpenConfirm={this.resetRegistration} confirmed={this.confirmed} />
    //         </Modal.Body>
    //     );
    // // }
  };

  confirmed = () => {
    this.resetRegistration();
    this.props.history.push("/profile");
  };

  // hideAndShowScoreBoard = (matchDetails) => {
  //     this.setState({
  //         showScoreBoard: !this.state.showScoreBoard,
  //         matchDetails: !this.state.showScoreBoard === true ? matchDetails : null
  //     });
  // }

  hideAndShowScoreBoard = (matchDetails, matchNo) => {
    if (matchDetails?.resultAdded) {
      // Track scoreboard view
      trackEvent("tournament_match_scoreboard_view", {
        tournament_id: this.state.tournamentDetails?._id,
        match_id: matchDetails?._id,
        match_number: matchNo,
        has_result: true,
        tournament_type: this.state.tournamentDetails?.stages[0]?.type,
        tournament_subtype: this.state.stageDetails?.subType || this.props.stageDetails?.subType,
      });

      this.setState({
        showScoreBoard: !this.state.showScoreBoard,
        matchDetails: !this.state.showScoreBoard === true ? matchDetails : null,
        matchNo,
      });
    }
  };

  // Helper method to check if user is organization owner
  isOrganizationOwner = () => {
    const currentUser = profile();
    const organizationDetails = this.state.tournamentDetails?.organizationDetails;

    if (!currentUser?.id || !organizationDetails?.members?.owner) {
      return false;
    }

    return organizationDetails.members.owner.includes(currentUser.id);
  };

  handleChatClick = (tournamentId, participantType, matchId) => {
    if (!tournamentId || !participantType || !matchId) {
      toast.error("Invalid tournament ID or match details.");
      return;
    }

    const currentUser = profile();
    if (!currentUser || !currentUser.id) {
      toast.error("Please login to access the chat.");
      return;
    }

    // Check if user is organization owner - they can access any chat
    if (this.isOrganizationOwner()) {
      const chatUrl = `/tournament/${tournamentId}/chatlobby/${participantType}/${matchId}`;
      window.open(chatUrl, "_blank");
      return;
    }

    const matchesApi = new MatchesApis();
    const requestData = {
      userId: currentUser.id,
      matchId: matchId,
    };

    matchesApi
      .isParticipantInMatch(requestData)
      .then(response => {
        if (response.data && response.data.result) {
          const result = response.data.result;

          // Check if user is in match (backend returns role and message if user exists)
          if (result.role) {
            // User is in match, redirect to chat
            const chatUrl = `/tournament/${tournamentId}/chatlobby/${participantType}/${matchId}`;
            window.open(chatUrl, "_blank");
          } else {
            // User is not in match
            toast.warning("You are not a participant in this match.");
          }
        } else {
          toast.error("Unable to verify your participation in this match.");
        }
      })
      .catch(error => {
        console.error("Error checking participant status:", error);
        if (error.response && error.response.data && error.response.data.error) {
          toast.error(error.response.data.error);
        } else {
          toast.error("Something went wrong while checking your participation.");
        }
      });
  };

  render() {
    if (this.state.stageDetails) {
      if (this.state.showRegistrationScreen) {
        return (
          <Registration
            tournamentDetails={this.state.tournamentDetails}
            stageDetails={this.state.stageDetails}
            selectedMatchDetail={this.state.selectedMatchDetail}
            matchIndex={this.state.matchIndex}
            selectedTeams={this.state.selectedTeams}
          />
        );
      } else {
        if (this.state.showScoreBoard) {
          return (
            <Scoreboard
              matchDetails={this.state.matchDetails}
              hideAndShowScoreBoard={this.hideAndShowScoreBoard}
              tournamentDetails={this.state.tournamentDetails}
              matchNo={this.state.matchNo}
            />
          );
        } else {
          const isTeamPlayer =
            this.state.tournamentDetails?.participantType === "TEAM" ? true : false;
          return (
            <div id="tournament-date">
              {/* Brackets Structure */}
              <div
                className="w-100 d-flex overflow-auto"
                style={{ height: "-webkit-fill-available" }}
              >
                <div
                  className=""
                  style={{
                    transform: `scale(${this.state.scale})`,
                    transformOrigin: `0% 0% 0px`,
                    overflow: "none",
                    width: "fit-content",
                  }}
                >
                  {Object.keys(this.state.stageDetails.groups[0]).map((key, i) => {
                    return (
                      <div className="py-1 px-3" key={key}>
                        <button
                          type="button"
                          className={`green-olive-card rounded-1 text-warning score-showdown-btn me-2 pt-1 rounds mt-2`}
                        >
                          ROUND {key}
                        </button>
                        <div className="d-flex flex-row overflow-auto my-3">
                          {this.state.stageDetails?.groups[0][key]?.map((match, index) => {
                            if (typeof match === "object") {
                              const dateAndTime = getMonthAndDate(match.matchSchedule);
                              const players = [];

                              for (
                                let j = 0;
                                j < this.state.stageDetails.maxParticipantsPerMatch;
                                j++
                              ) {
                                const player = match.participants[j] ? match.participants[j] : null;

                                if (match.resultAdded && player && player !== undefined) {
                                  player.isWinner = match?.finalResult[j]?.isWinner;
                                }

                                players.push(player);
                              }
                              const canParticipate = showHideMatchInvite(
                                match,
                                this.state.tournamentDetails
                              );

                              const matchNo = `M ${key}.${index + 1}`;
                              return (
                                <div
                                  className="d-flex flex-column align-items-center"
                                  key={`${key}.${index + 1}`}
                                >
                                  {(this.state?.tournamentDetails.participantUserId.includes(
                                    profile()?.id
                                  ) ||
                                    this.isOrganizationOwner()) && (
                                    <div
                                      className="d-flex justify-content-center fw-bold text-white my-2 cursor-pointer"
                                      onClick={() => {
                                        const { _id, participantType } =
                                          this.state.tournamentDetails || {};
                                        const matchId = match?._id;

                                        if (_id && participantType && matchId) {
                                          this.handleChatClick(_id, participantType, matchId);
                                        }
                                      }}
                                    >
                                      <HiChatBubbleLeftRight className="btn-size-15 me-1 fs-18" />
                                      <span className="fs-14">Team Chat</span>
                                    </div>
                                  )}
                                  <div
                                    onClick={() => this.hideAndShowScoreBoard(match, matchNo)}
                                    className="tournament-btn green-flat-btn d-flex flex-column justify-content-start align-items-start flex-shrink-0 me-2 pb-2 mt-2"
                                    style={{ height: "auto", width: "320px" }}
                                  >
                                    <span className="match-tag bg-black text-warning">
                                      Match {key}.{index + 1}
                                    </span>
                                    <div className="row ms-0 w-100 mt-1 justify-content-between">
                                      <div className="col-5">
                                        <div className="d-flex flex-column">
                                          {players.map((player, ind) => {
                                            if (player !== null) {
                                              return (
                                                <div
                                                  className="d-flex align-items-center"
                                                  key={ind}
                                                >
                                                  <span
                                                    className="player-name d-flex align-items-center my-1 text-black text-truncate"
                                                    key={ind}
                                                  >
                                                    <span className="m-w-20">
                                                      <Image
                                                        src={
                                                          isTeamPlayer
                                                            ? player?.logo?.url
                                                            : player?.profilePicture?.url
                                                        }
                                                        param={
                                                          isTeamPlayer
                                                            ? player.name
                                                            : player.inGameName
                                                        }
                                                        className="btn-size-20 rounded-circle rounded me-2"
                                                      />
                                                    </span>
                                                    {isTeamPlayer ? player.name : player.inGameName}
                                                  </span>
                                                  {match.resultAdded && player.isWinner ? (
                                                    <img
                                                      src={winCup}
                                                      className="btn-size-15 ms-2"
                                                      alt=""
                                                    />
                                                  ) : null}
                                                </div>
                                              );
                                            } else {
                                              return (
                                                <span
                                                  key={ind}
                                                  className="fs-12 fw-bold text-white my-1"
                                                >
                                                  Vacant
                                                </span>
                                              );
                                            }
                                          })}
                                        </div>
                                      </div>
                                      {key == 1 && canParticipate ? (
                                        <div className="col-3 d-flex align-items-center justify-content-center">
                                          {this.state.stageDetails.level !== 1 ||
                                          match.participants.length ===
                                            this.state.stageDetails
                                              .maxParticipantsPerMatch ? null : (
                                            <button
                                              onClick={e =>
                                                this.registerForTournament(
                                                  e,
                                                  match,
                                                  `1.${index + 1}`
                                                )
                                              }
                                              className="round-btn rounded-circle d-flex align-items-center justify-content-center border-0 btn-size-40 mx-2"
                                            >
                                              <HiUserAdd className="btn-size-15" />
                                            </button>
                                          )}
                                        </div>
                                      ) : null}

                                      <div className="col-4 d-flex align-items-center justify-content-end">
                                        <div className="d-flex flex-column float-end">
                                          <span className="fs-12 fw-bold text-black my-1">
                                            {dateAndTime[0]}
                                          </span>
                                          <span className="fs-12 fw-bold text-black">
                                            {dateAndTime[1]}
                                          </span>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              );
                            }
                          })}
                        </div>
                      </div>
                    );
                  })}
                </div>
              </div>

              {/* Tournament Invitation Section */}
              <Modal
                centered
                show={this.state.initiateRegistration}
                dialogClassName="ClanInvite-modal"
              >
                {this.state.tournamentDetails?.participantType === "SINGLE" ? (
                  this.onClickRegister()
                ) : (
                  <Modal.Body>
                    <MatchInvite
                      onClickOpenInvite={this.onClickOpenInvite}
                      teamsArray={this.state.teamsArray}
                      choice="Join Tournament"
                      isRoundRobin={false}
                    />
                  </Modal.Body>
                )}
              </Modal>
            </div>
          );
        }
      }
    } else {
      return (
        <div>
          <h1>No Data Found</h1>
        </div>
      );
    }
  }
}
